var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[this.classes, 'toggle-switch']},[_c('input',{attrs:{"type":"checkbox","name":this.name},domProps:{"checked":_vm.value},on:{"change":_vm.emitInput}}),_c('label',{on:{"click":_vm.emitInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }